import styled from '@emotion/styled'

export const SelectedList = styled.div`
  display: flex;
  flex-direction: row;
  overflow-x: auto;
  flex: 0 0 auto;
`
